import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '../../store';

export const selectRoot = ({ router }: RootState) => router;

export const selectLocation = createSelector(
    selectRoot,
    route => route.location,
);
